var klaviyo = klaviyo || [];
klaviyo.init({
    account: "XnX3nj",
    platform: "shopify"
});
klaviyo.enable("backinstock",{
    trigger: {
        product_page_text: "Notify Me When Available",
        product_page_class: "goddiva-back-stock button",
        product_page_text_align: "center",
        product_page_margin: "0px",
        replace_anchor: false
    },
    modal: {   
        headline: "{product_name}",
        body_content: "Register to receive a notification when this item comes back in stock.",
        email_field_label: "Email",
        button_label: "Notify me when available",
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        drop_background_color: "#000",
        background_color: "#fff",
        text_color: "#222",
        button_text_color: "#fff",
        button_background_color: "#000000",
        close_button_color: "#ccc",
        error_background_color: "#fcd6d7",
        error_text_color: "#C72E2F",
        success_background_color: "#d3efcd",
        success_text_color: "#1B9500"
    }
});